export const focus = {
  ring: {
    outline: '1px solid black',
  },
};
